import { useState } from 'react';
import Logger from '../../../../../../../../common/logger';
import 'regenerator-runtime/runtime.js';

const HOST = 'https://www.orange.pl';
// const HOST = 'http://localhost:3002';
// const HOST = 'https://json-server-mock.azurewebsites.net/';

const useSuggestionApi = () => {
    const [suggestions, setSuggestions] = useState({
        city: [],
        street: [],
        postalCode: ''
    });
    const [suggestionsSelected, setSuggestionsSelected] = useState({
        city: '',
        street: '',
        postalCode: ''
    });

    const fetchCBSSuggestions = async ({ api, body }) => {
        return await fetch(HOST + api, {
            method: 'post',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            body: body
        });
    };

    const fetchWWTSuggestions = async ({ cityId, streetId, streetNr }) => {
        return await fetch(
            `${HOST}/wwt/streetZips?placeId=${cityId}&streetId=${streetId}&streetNumber=${streetNr}`
        );
    };

    const onCityFieldChange = async (event) => {
        const value = event.target.value;
        if (value.length > 2) {
            try {
                const response = await fetchCBSSuggestions({
                    api: '/hapi/cbs/cityauto',
                    body: JSON.stringify({
                        filter: '',
                        html: value
                    })
                });
                const data = await response.json();
                Logger.log('onCityFieldChange: ' + JSON.stringify(data));
                setSuggestions({
                    ...suggestions,
                    city: data
                });
                const cityName = suggestions.city.find((cs) => cs.name === value);
                if (!cityName) {
                    setSuggestionsSelected({
                        ...suggestionsSelected,
                        city: ''
                    });
                }
            } catch (error) {
                Logger.log('onCityFieldChange: ' + error);
            }
        } else {
            setSuggestions({
                ...suggestions,
                city: []
            });
        }
    };

    const onCityFieldSelected = (id) => {
        const city = suggestions.city.find((cs) => cs.id === id);
        if (city) {
            setSuggestionsSelected({
                ...suggestionsSelected,
                city: id
            });
        }
    };

    const onStreetFieldChange = async (event) => {
        const value = event.target.value;
        if (!suggestionsSelected.city) {
            return;
        }
        if (value.length > 2) {
            try {
                const response = await fetchCBSSuggestions({
                    api: '/hapi/cbs/streetauto',
                    body: JSON.stringify({
                        filter: { city_id: suggestionsSelected.city },
                        html: value
                    })
                });
                const data = await response.json();
                Logger.log('onStreetFieldChange: ' + JSON.stringify(data));
                setSuggestions({
                    ...suggestions,
                    street: data
                });
                const streetName = suggestions.street.find((cs) => cs.name === value);
                if (!streetName) {
                    setSuggestionsSelected({
                        ...suggestionsSelected,
                        street: ''
                    });
                }
            } catch (error) {
                Logger.log('onStreetFieldChange: ' + error);
            }
        }
        if (!value || value.length <= 2) {
            setSuggestions({
                ...suggestions,
                street: []
            });
        }
    };

    const onStreetFieldSelected = async (id) => {
        const street = suggestions.street.find((cs) => cs.id === id);
        if (street) {
            setSuggestionsSelected({
                ...suggestionsSelected,
                street: id
            });
        }
    };

    const onStreetNumberSelected = async (number) => {
        if (!number) {
            setSuggestions({
                ...suggestions,
                postalCode: ''
            });
            return;
        }

        if (!suggestionsSelected.city || !suggestionsSelected.street) {
            return;
        }

        let postalCode = '';
        try {
            const response = await fetchWWTSuggestions({
                cityId: suggestionsSelected.city,
                streetId: suggestionsSelected.street,
                streetNr: number
            });
            const data = await response.json();
            Logger.log('onStreetNumberSelected: ' + JSON.stringify(data));
            if (data && data.length > 0) {
                postalCode = data[0].value;
                setSuggestionsSelected({
                    ...suggestionsSelected,
                    postalCode: data[0].value
                });
            }
        } catch (error) {
            Logger.log('onStreetNumberSelected: ' + error);
        }

        setSuggestions({
            ...suggestions,
            postalCode: postalCode
        });
    };

    return {
        citySuggestions: suggestions.city,
        onCityFieldChange,
        onCityFieldSelected,
        streetSuggestions: suggestions.street,
        onStreetFieldChange,
        onStreetFieldSelected,
        onStreetNumberSelected,
        postalCodeSuggestion: suggestions.postalCode,
        suggestionsSelected
    };
};

export default useSuggestionApi;
